import locales from 'dayjs/locale.json'

import { dayjs } from '@tribeplatform/react-components/common'

const validateLocale = (localeString: string): string => {
  const normalizedLocale = localeString.toLowerCase()
  const [mainLocale] = normalizedLocale.split('-')
  const locale = locales.find(
    locale => locale.key === normalizedLocale || locale.key === mainLocale,
  )
  if (locale) {
    return locale.key
  }
  return 'en'
}

export const localizeDayJs = async (locale: string) => {
  const dayJsLocale = validateLocale(locale)
  await import(
    /* webpackInclude: /(de|en|es|fr|ko|pt|tr|zh)(-[A-Za-z]{2})?\.js$/ */
    /* webpackChunkName: "dayjs-locale-[request]" */
    /* webpackMode: "lazy" */
    /* webpackPrefetch: false */
    /* webpackPreload: false */
    `dayjs/locale/${dayJsLocale}.js`
  )
  dayjs.locale(dayJsLocale)
}
